import { Navigate } from "react-router-dom";
import { useCurrentTramite } from "@/hooks/useCurrentTramite";
import { useCanChangeName } from "@/hooks/useCanChangeName";

export type WithRequiredTramiteProps = {
  tramite: ReturnType<typeof useCurrentTramite>;
  canChangeName: ReturnType<typeof useCanChangeName>;
}

export function withRequiredTramite<T>(Component: React.ComponentType<WithRequiredTramiteProps>): React.FC<WithRequiredTramiteProps> {
  return (props) => {
    const tramite = useCurrentTramite();
    const canChangeName = useCanChangeName();
    if (!tramite) {
      return <Navigate to="/" replace />;
    }

    const WrappedComponent = Component as React.ComponentType<WithRequiredTramiteProps>;
    WrappedComponent.displayName = `withRequiredTramite(${Component.displayName || Component.name || 'Component'})`;

    return <WrappedComponent {...props} tramite={tramite} canChangeName={canChangeName} />;
  };
}

